import {Box, CircularProgress, Stack, useMediaQuery, useTheme} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import type * as React from 'react';
import GuestHeaderLinks from '@/components/Navigation/GuestHeaderLinks';
import Hamburger from '@/components/Navigation/Hamburger.tex';
import Logo from '@/components/Navigation/Logo';
import UserHeaderLinks from '@/components/Navigation/UserHeaderLinks';
import {useUserContext} from '@/components/Providers/UserContext';

const Header = () : React.ReactElement => {
    const theme = useTheme();
    const isMdOrSmaller = useMediaQuery(theme.breakpoints.down('md'));
    const {user} = useUserContext();

    if (user === undefined) {
        return <Container sx={{height: '100%'}}>
            <Stack
                direction='row'
                justifyContent='center'
                alignItems='center'
                sx={{
                    height: '100%',
                }}
            >
                <CircularProgress/>
            </Stack>
        </Container>;
    }

    return (
        <AppBar
            sx={{
                backgroundColor: '#fff',
            }}
            elevation={0}
        >
            <Container>
                <Toolbar disableGutters>
                    <Stack
                        direction='row'
                        justifyContent='space-between'
                        alignItems='center'
                        sx={{
                            width: '100%',
                        }}
                    >
                        <Logo/>
                        {!user && <Box sx={{height: '100%'}}>
                            {!isMdOrSmaller && <GuestHeaderLinks/>}
                        </Box>}
                        {user && <Box>
                            {isMdOrSmaller && <Hamburger/>}
                            {!isMdOrSmaller && <UserHeaderLinks/>}
                        </Box>}
                    </Stack>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Header;
